<template>
  <div>
    <h1 class="mb-2 text-3xl font-bold">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('mahasiswa.edit.self')">
        Mahasiswa
      </inertia-link>
      <span class="font-medium text-indigo-400">/</span>
      {{ form.name }}
    </h1>
    <span class="mb-6 text-xl font-semibold">Status: {{ verificationStatus }}</span>
    <trashed-message
      v-if="mahasiswa.deleted_at"
      class="mb-6"
      @restore="restore">
      This mahasiswa has been deleted.
    </trashed-message>
    <form @submit.prevent="update">
      <tab-view
        :step="lastInputStep"
        :open-tab="currentTab"
        @tab-changed="onTabChanged">
        <template #tab1>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <text-input
              v-model="form.name"
              :error="form.errors.name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Nama Lengkap"
              :disabled="isReadonly" />
            <text-input
              v-model="form.pob"
              :error="form.errors.pob"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Tempat Lahir"
              :disabled="isReadonly" />
            <text-input
              v-model="form.dob"
              v-mask="'##/##/####'"
              :error="form.errors.dob"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Tanggal Lahir"
              placeholder="dd/mm/yyyy"
              :disabled="isReadonly" />
            <select-input
              v-model="form.gender"
              :error="form.errors.gender"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Jenis Kelamin"
              :disabled="isReadonly">
              <option value="PRIA">
                PRIA
              </option>
              <option value="WANITA">
                WANITA
              </option>
            </select-input>
            <text-input
              v-model="form.nik"
              :error="form.errors.nik"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No KTP"
              :max-length="16"
              :disabled="isReadonly" />
            <text-input
              v-model="form.no_kk"
              :error="form.errors.no_kk"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Nomor Kartu Keluarga"
              :max-length="16"
              :disabled="isReadonly" />
            <text-input
              v-model="form.nim"
              :error="form.errors.nim"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Nomor Induk Mahasiswa"
              :max-length="25"
              :disabled="isReadonly" />
            <text-input
              v-model="form.phone_number"
              :error="form.errors.phone_number"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No Handphone"
              :max-length="14"
              :disabled="isReadonly" />
            <text-input
              v-model="form.phone_number_wa"
              :error="form.errors.phone_number_wa"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No Whatsapp"
              :max-length="14"
              :disabled="isReadonly" />
            <text-input
              v-model="form.email"
              :error="form.errors.email"
              class="pr-6 pb-8 w-full md:w-1/3"
              label="Email Mahasiswa"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.address_origin"
              :max-length="190"
              :error="form.errors.address_origin"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Alamat Asal mahasiswa/i di kab.puncak"
              :disabled="isReadonly" />
            <distrik-kampung-picker
              :value-distrik="form.ref_distrik_id"
              :value-kampung="form.ref_kampung_id"
              :error-distrik="form.errors.ref_distrik_id"
              :error-kampung="form.errors.ref_kampung_id"
              :disabled="isReadonly"
              :distriks="distriks"
              :kampungs="kampungs"
              @input-distrik="onDistrikSelected"
              @input-kampung="onKampungSelected" />
            <text-input
              v-model="form.distrik_head_name"
              :error="form.errors.distrik_head_name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Nama Kepala Distrik"
              :disabled="isReadonly" />
            <text-input
              v-model="form.kampung_head_name"
              :error="form.errors.kampung_head_name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Nama Kepala Kampung"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.address_current"
              :max-length="190"
              :error="form.errors.address_current"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Alamat Domisili mahasiswa/i saat ini"
              :disabled="isReadonly" />

            <div
              class="relative w-full h-5 after:absolute after:top-0 after:left-0 after:w-full after:h-full after:pointer-events-none after:z-20" />

            <text-input
              v-model="form.shs_name"
              :error="form.errors.shs_name"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Nama SMA/SMU/SMK"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.shs_address"
              :error="form.errors.shs_address"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Alamat SMA/SMU/SMK"
              :disabled="isReadonly" />
            <text-input
              v-model="form.shs_phone_number"
              :error="form.errors.shs_phone_number"
              class="pr-6 pb-8 w-full md:w-1/4"
              :max-length="14"
              label="No. Telp SMA/SMU/SMK"
              :disabled="isReadonly" />

            <div
              class="relative w-full h-5 after:absolute after:top-0 after:left-0 after:w-full after:h-full after:pointer-events-none after:z-20" />

            <text-input
              v-model="form.bank_acc_number"
              :error="form.errors.bank_acc_number"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No Rekening Mahasiswa"
              :disabled="isReadonly" />
            <text-input
              v-model="form.bank_acc_name"
              :error="form.errors.bank_acc_name"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Nama Pemilik Rekening"
              :disabled="isReadonly" />
            <select-input
              v-model="form.ref_bank_id"
              :error="form.errors.ref_bank_id"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Nama Bank"
              :disabled="isReadonly">
              <option :value="null" />
              <option
                v-for="bank in banks"
                :key="bank.id"
                :value="bank.id">
                {{ bank.name }}
              </option>
            </select-input>
          </div>
        </template>
        <template #tab2>
          <div
            class="absolute invisible -my-5 h-full border border-gray-700 border-opacity-20 lg:visible border-2-2"
            style="left: 50%" />
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <select-input
              v-model="form.is_father_alive"
              :error="form.errors.is_father_alive"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Status Ayah"
              :disabled="isReadonly">
              <option :value="1">
                MASIH HIDUP
              </option>
              <option :value="0">
                SUDAH MENINGGAL
              </option>
            </select-input>
            <text-input
              v-model="form.father_nik"
              :error="form.errors.father_nik"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No KTP Ayah"
              :max-length="16"
              :disabled="isReadonly" />
            <select-input
              v-model="form.is_mother_alive"
              :error="form.errors.is_mother_alive"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Status Ibu"
              :disabled="isReadonly">
              <option :value="1">
                MASIH HIDUP
              </option>
              <option :value="0">
                SUDAH MENINGGAL
              </option>
            </select-input>
            <text-input
              v-model="form.mother_nik"
              :error="form.errors.mother_nik"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No KTP Ibu"
              :max-length="16"
              :disabled="isReadonly" />
            <text-input
              v-model="form.father_name"
              :error="form.errors.father_name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Nama Lengkap Ayah"
              :disabled="isReadonly" />
            <text-input
              v-model="form.mother_name"
              :error="form.errors.mother_name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Nama Lengkap Ibu"
              :disabled="isReadonly" />
            <text-input
              v-model="form.father_pob"
              :error="form.errors.father_pob"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Tempat Lahir Ayah"
              :disabled="isReadonly" />
            <text-input
              v-model="form.father_dob"
              v-mask="'##/##/####'"
              :error="form.errors.father_dob"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Tanggal Lahir Ayah"
              placeholder="dd/mm/yyyy"
              :disabled="isReadonly" />
            <text-input
              v-model="form.mother_pob"
              :error="form.errors.mother_pob"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Tempat Lahir Ibu"
              :disabled="isReadonly" />
            <text-input
              v-model="form.mother_dob"
              v-mask="'##/##/####'"
              :error="form.errors.mother_dob"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Tanggal Lahir Ibu"
              placeholder="dd/mm/yyyy"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.father_address_current"
              :error="form.errors.father_address_current"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Alamat Ayah (sesuai KTP)"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.father_address_origin"
              :error="form.errors.father_address_origin"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Alamat Lengkap Asal Ayah"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.mother_address_current"
              :error="form.errors.mother_address_current"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Alamat Ibu (sesuai KTP)"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.mother_address_origin"
              :error="form.errors.mother_address_origin"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Alamat Lengkap Asal Ibu"
              :disabled="isReadonly" />
            <text-input
              v-model="form.father_phone_number"
              :error="form.errors.father_phone_number"
              class="pr-6 pb-8 w-full md:w-1/4"
              :max-length="14"
              label="No Telp Ayah"
              :disabled="isReadonly" />
            <text-input
              v-model="form.father_job"
              :error="form.errors.father_job"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Pekerjaan Ayah"
              :disabled="isReadonly" />
            <text-input
              v-model="form.mother_phone_number"
              :error="form.errors.mother_phone_number"
              class="pr-6 pb-8 w-full md:w-1/4"
              :max-length="14"
              label="No Telp Ibu"
              :disabled="isReadonly" />
            <text-input
              v-model="form.mother_job"
              :error="form.errors.mother_job"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Pekerjaan Ibu"
              :disabled="isReadonly" />
          </div>
        </template>
        <template #tab3>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <select-input
              v-model="form.ref_universitas_id"
              :error="form.errors.ref_universitas_id"
              class="pr-6 pb-8 w-full md:w-3/6"
              label="Nama Universitas"
              :disabled="isReadonly">
              <option :value="null" />
              <option
                v-for="universitas in universities"
                :key="universitas.id"
                :value="universitas.id">
                {{ universitas.name }}
              </option>
            </select-input>
            <text-input
              v-model="form.university_accreditation"
              :error="form.errors.university_accreditation"
              class="pr-6 pb-8 w-full md:w-1/6"
              label="Akreditasi"
              :disabled="isReadonly" />
            <text-area-input
              v-model="form.university_address"
              :error="form.errors.university_address"
              class="pr-6 pb-8 w-full md:w-2/6"
              label="Alamat Kampus"
              :disabled="isReadonly" />
            <text-input
              v-model="form.university_email"
              :error="form.errors.university_email"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Email Universitas"
              :disabled="isReadonly" />
            <text-input
              v-model="form.university_phone"
              :error="form.errors.university_phone"
              :max-length="14"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No. Telp Universitas"
              :disabled="isReadonly" />
            <text-input
              v-model="form.university_rector_name"
              :error="form.errors.university_rector_name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Nama Lengkap Rektor/Ketua/Direktur"
              :disabled="isReadonly" />
            <text-input
              v-model="form.prodi_name"
              :error="form.errors.prodi_name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Prodi"
              placeholder="Ketikkan nama prodi tanpa disingkat"
              :disabled="isReadonly" />
            <text-input
              v-model="form.prodi_head_name"
              :error="form.errors.prodi_head_name"
              class="pr-6 pb-8 w-full md:w-1/2"
              label="Nama Lengkap Kepala Program Studi/Jurusan"
              :disabled="isReadonly" />
            <text-input
              v-model="form.prodi_staff_name"
              :error="form.errors.prodi_staff_name"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="Nama Staff Bagian Kemahasiswaan"
              :disabled="isReadonly" />
            <text-input
              v-model="form.prodi_staff_phone"
              :error="form.errors.prodi_staff_phone"
              :max-length="14"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No Telepon Bagian Kemahasiswaan"
              :disabled="isReadonly" />
            <text-input
              v-model="form.prodi_staff_mobile"
              :error="form.errors.prodi_staff_mobile"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No Handphone Bagian Kemahasiswaan"
              :disabled="isReadonly" />
            <text-input
              v-model="form.prodi_staff_wa"
              :error="form.errors.prodi_staff_wa"
              class="pr-6 pb-8 w-full md:w-1/4"
              label="No Whatsapp Bagian Kemahasiswaan"
              :disabled="isReadonly" />
            <select-input
              v-model="form.ref_jenjang_pendidikan_id"
              :error="form.errors.ref_jenjang_pendidikan_id"
              class="pr-6 pb-8 w-full md:w-1/5"
              label="Jenjang Pendidikan"
              :disabled="isReadonly">
              <option :value="null" />
              <option
                v-for="jenjang_pendidikan in jenjangPendidikans"
                :key="jenjang_pendidikan.id"
                :value="jenjang_pendidikan.id">
                {{ jenjang_pendidikan.name }}
              </option>
            </select-input>
            <text-input
              v-model="form.college_entry_year"
              :error="form.errors.college_entry_year"
              class="pr-6 pb-8 w-full md:w-1/5"
              label="Tahun Masuk Kuliah"
              :disabled="isReadonly" />
            <text-input
              v-model="form.current_semester"
              :error="form.errors.current_semester"
              class="pr-6 pb-8 w-full md:w-1/5"
              label="Semester"
              :disabled="isReadonly" />
            <text-input
              v-model="form.current_gpa"
              :error="form.errors.current_gpa"
              class="pr-6 pb-8 w-full md:w-1/5"
              label="IPK"
              placeholder="0.00 - 4.00"
              :disabled="isReadonly" />
            <text-input
              v-model="form.scholarship_bank_acc_number"
              :error="form.errors.scholarship_bank_acc_number"
              class="pr-6 pb-8 w-full md:w-1/3"
              label="No Rekening Bank (Kampus)"
              :disabled="isReadonly" />
            <text-input
              v-model="form.scholarship_bank_acc_name"
              :error="form.errors.scholarship_bank_acc_name"
              class="pr-6 pb-8 w-full md:w-1/3"
              label="Nama Pemilik Rekening (Kampus)"
              :disabled="isReadonly" />
            <select-input
              v-model="form.scholarship_bank_id"
              :error="form.errors.scholarship_bank_id"
              class="pr-6 pb-8 w-full md:w-1/3"
              label="Nama Bank (Kampus)"
              :disabled="isReadonly">
              <option :value="null" />
              <option
                v-for="bank in banks"
                :key="bank.id"
                :value="bank.id">
                {{ bank.name }}
              </option>
            </select-input>
          </div>
        </template>
        <template #tab4>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.nik_file"
              :error="uploads.errors.nik_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="KTP Mahasiswa"
              :disabled="isReadonly"
              @input="autoUploadBerkas('nik_file')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.nik_file"
                class="btn-green"
                type="button"
                @click.prevent="previewFile('nik_file')">
                Preview
              </button>
            </div>
          </div>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.no_kk_file"
              :error="uploads.errors.no_kk_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="KK Mahasiswa"
              :disabled="isReadonly"
              @input="autoUploadBerkas('no_kk_file')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.no_kk_file"
                class="btn-green"
                type="button"
                @click.prevent="previewFile('no_kk_file')">
                Preview
              </button>
            </div>
          </div>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.photo"
              :error="uploads.errors.photo"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="Pasfoto Mahasiswa (Berwarna, Ukuran 4x6)"
              :disabled="isReadonly"
              @input="autoUploadBerkas('photo')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.photo"
                class="btn-green"
                type="button"
                @click.prevent="previewFile('photo')">
                Preview
              </button>
            </div>
          </div>
          <div v-if="form.is_father_alive" class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.father_nik_file"
              :error="uploads.errors.father_nik_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="KTP Ayah"
              :disabled="isReadonly"
              @input="autoUploadBerkas('father_nik_file')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.father_nik_file"
                class="btn-green"
                type="button"
                @click.prevent="previewFile('father_nik_file')">
                Preview
              </button>
            </div>
          </div>
          <div v-if="form.is_mother_alive" class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.mother_nik_file"
              :error="uploads.errors.mother_nik_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="KTP Ibu"
              :disabled="isReadonly"
              @input="autoUploadBerkas('mother_nik_file')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.mother_nik_file"
                class="btn-green"
                type="button"
                @click.prevent="previewFile('mother_nik_file')">
                Preview
              </button>
            </div>
          </div>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.bank_acc_file"
              :error="uploads.errors.bank_acc_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="Scan buku rekening Mahasiswa"
              :disabled="isReadonly"
              @input="autoUploadBerkas('bank_acc_file')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.bank_acc_file"
                class="btn-green"
                type="button"
                @click.prevent="previewFile('bank_acc_file')">
                Preview
              </button>
            </div>
          </div>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.statement_doc_file"
              :error="uploads.errors.statement_doc_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="Scan dokumen surat pernyataan"
              :disabled="isReadonly"
              @input="autoUploadBerkas('statement_doc_file')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.statement_doc_file"
                class="btn-green"
                type="button"
                @click.prevent="
                  previewFile('statement_doc_file')
                ">
                Preview
              </button>
            </div>
          </div>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.student_id_file"
              :error="uploads.errors.student_id_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="KTM Mahasiswa"
              :disabled="isReadonly"
              @input="autoUploadBerkas('student_id_file')" />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.student_id_file"
                class="btn-green"
                type="button"
                @click.prevent="previewFile('student_id_file')">
                Preview
              </button>
            </div>
          </div>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <file-input
              v-model="uploads.recommendation_letter_file"
              :error="uploads.errors.recommendation_letter_file"
              class="pr-6 pb-4 w-full md:w-1/2"
              type="file"
              accept="image/*"
              label="Surat Rekomendasi Ikatan Mahasiswa"
              :disabled="isReadonly"
              @input="
                autoUploadBerkas('recommendation_letter_file')
              " />
            <div class="items-start pr-6 mt-8 -ml-4 w-full md:w-1/2">
              <button
                v-if="mahasiswa.recommendation_letter_file"
                class="btn-green"
                type="button"
                @click.prevent="
                  previewFile('recommendation_letter_file')
                ">
                Preview
              </button>
            </div>
          </div>
          <progress
            v-if="uploads.progress"
            :value="uploads.progress.percentage"
            max="100">
            {{ uploads.progress.percentage }}%
          </progress>
        </template>
      </tab-view>
      <div v-if="!isReadonly" class="flex justify-end py-4 mx-2 bg-gray-50 border-t border-gray-100">
        <div v-show="currentTab !== 4" class="mr-2">
          <loading-button
            :loading="form.processing"
            class="ml-auto btn-indigo"
            type="submit"
            title="Simpan Data dan Lanjut penginputan ke tab berikutnya">
            {{
              lastInputStep > 3 ? "Simpan" : "Simpan &amp; Lanjut"
            }}
          </loading-button>
        </div>
        <div v-if="lastInputStep > 3">
          <button
            class="ml-auto btn-green"
            type="button"
            @click.prevent="showTermModal">
            Pengajuan Verifikasi
          </button>
        </div>
      </div>
    </form>
    <modal :is-modal-show="isModalVisible" @close="closeModal">
      <template slot="header">
        Preview Document
      </template>
      <template slot="body">
        <div class="flex justify-center">
          <blob-image :src="imgUrl" />
        </div>
      </template>
    </modal>
    <modal
      :is-modal-show="isTermConfirmVisible"
      close-btn-text="Close"
      :is-footer-show="true"
      @close="closeTermModal">
      <template slot="header">
        Konfirmasi Pengajuan Verifikasi Data Mahasiswa
      </template>
      <template slot="body">
        <div>
          <ul class="py-2 pl-4 list-disc">
            <li>
              Setelah mengkonfirmasi pengajuan verifikasi
              Mahasiswa tidak bisa lagi mengubah profile dan
              biodata.
            </li>
            <li>
              Pastikan sudah melengkapi inputan form yang di
              wajibkan, dan juga mengecek kembali (preview)
              berkas-berkas syarat yang telah diupload.
            </li>
          </ul>
        </div>
        <div class="p-4 mx-auto max-w-xs">
          <label class="flex items-center space-x-3">
            <input
              v-model="isConfirmed"
              type="checkbox"
              name="confirmed-check">
            <span class="font-medium text-gray-900" for="confirmed-check">Saya sudah mengerti.</span>
          </label>
        </div>
      </template>
      <template slot="footer">
        <span v-show="!isConfirmed" class="italic">*) Tombol <strong>Ajukan Verifikasi</strong> baru akan
          muncul jika sudah ada checklist sudah di isi</span>
        <form @submit.prevent="verifikasi">
          <loading-button
            v-if="isConfirmed"
            :loading="form.processing"
            class="ml-auto btn-green"
            type="submit">
            Ajukan Verifikasi
          </loading-button>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TabView from '@/Shared/TabView'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import BlobImage from '@/Shared/BlobImage'
import DistrikKampungPicker from '@/Shared/DistrikKampungPicker'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo () {
        return {
            title: `Edit Mahasiswa - ${this.form.name}`,
        }
    },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        TabView,
        TextAreaInput,
        FileInput,
        Modal,
        BlobImage,
        DistrikKampungPicker,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        mahasiswa: Object,
        verificationStatus: String,
        distriks: Array,
        kampungs: Array,
        banks: Array,
        universities: Array,
        jenjangPendidikans: Array,
        isReadonly: Boolean,
    },
    remember: 'form',
    data () {
        return {
            imgUrl: null,
            isModalVisible: false,
            isTermConfirmVisible: false,
            isConfirmed: false,
            currentTab:
                this.mahasiswa.input_step < 4 ? this.mahasiswa.input_step : 1,
            lastInputStep: this.mahasiswa.input_step,
            form: useForm({
                name: this.mahasiswa.name,
                pob: this.mahasiswa.pob,
                dob: this.mahasiswa.dob,
                gender: this.mahasiswa.gender,
                email: this.mahasiswa.email,
                nik: this.mahasiswa.nik,
                nim: this.mahasiswa.nim,
                no_kk: this.mahasiswa.no_kk,
                phone_number: this.mahasiswa.phone_number,
                phone_number_wa: this.mahasiswa.phone_number_wa,
                address_origin: this.mahasiswa.address_origin,
                ref_distrik_id: this.mahasiswa.ref_distrik_id,
                ref_kampung_id: this.mahasiswa.ref_kampung_id,
                distrik_head_name: this.mahasiswa.distrik_head_name,
                kampung_head_name: this.mahasiswa.kampung_head_name,
                address_current: this.mahasiswa.address_current,
                is_father_alive: this.mahasiswa.is_father_alive,
                is_mother_alive: this.mahasiswa.is_mother_alive,
                father_name: this.mahasiswa.father_name,
                father_nik: this.mahasiswa.father_nik,
                father_pob: this.mahasiswa.father_pob,
                father_dob: this.mahasiswa.father_dob,
                father_address_current: this.mahasiswa.father_address_current,
                father_address_origin: this.mahasiswa.father_address_origin,
                father_phone_number: this.mahasiswa.father_phone_number,
                father_job: this.mahasiswa.father_job,
                mother_name: this.mahasiswa.mother_name,
                mother_nik: this.mahasiswa.mother_nik,
                mother_pob: this.mahasiswa.mother_pob,
                mother_dob: this.mahasiswa.mother_dob,
                mother_address_current: this.mahasiswa.mother_address_current,
                mother_address_origin: this.mahasiswa.mother_address_origin,
                mother_phone_number: this.mahasiswa.mother_phone_number,
                mother_job: this.mahasiswa.mother_job,
                shs_name: this.mahasiswa.shs_name,
                shs_address: this.mahasiswa.shs_address,
                shs_phone_number: this.mahasiswa.shs_phone_number,
                bank_acc_number: this.mahasiswa.bank_acc_number,
                bank_acc_name: this.mahasiswa.bank_acc_name,
                ref_bank_id: this.mahasiswa.ref_bank_id,
                ref_universitas_id: this.mahasiswa.ref_universitas_id,
                ref_prodi_id: this.mahasiswa.ref_prodi_id,
                ref_jenjang_pendidikan_id:
                    this.mahasiswa.ref_jenjang_pendidikan_id,
                college_entry_year: this.mahasiswa.college_entry_year,
                current_semester: this.mahasiswa.current_semester,
                current_gpa: this.mahasiswa.current_gpa,
                university_address: this.mahasiswa.university_address,
                university_email: this.mahasiswa.university_email,
                university_phone: this.mahasiswa.university_phone,
                university_rector_name: this.mahasiswa.university_rector_name,
                university_accreditation:
                    this.mahasiswa.university_accreditation,
                prodi_name: this.mahasiswa.prodi_name,
                prodi_head_name: this.mahasiswa.prodi_head_name,
                prodi_staff_name: this.mahasiswa.prodi_staff_name,
                prodi_staff_phone: this.mahasiswa.prodi_staff_phone,
                prodi_staff_mobile: this.mahasiswa.prodi_staff_mobile,
                prodi_staff_wa: this.mahasiswa.prodi_staff_wa,
                scholarship_bank_id: this.mahasiswa.scholarship_bank_id,
                scholarship_bank_acc_number:
                    this.mahasiswa.scholarship_bank_acc_number,
                scholarship_bank_acc_name: this.mahasiswa.bank_acc_name,
            }),
            uploads: useForm({
                doc_type: null,
                nik_file: null,
                no_kk_file: null,
                photo: null,
                father_nik_file: null,
                mother_nik_file: null,
                bank_acc_file: null,
                statement_doc_file: null,
                student_id_file: null,
                recommendation_letter_file: null,
            }),
        }
    },
    methods: {
        verifikasi () {
            this.form
                .transform((data) => ({
                    ...data,
                    _verified_attempt: true,
                }))
                .put(this.route('mahasiswa.update.self'), {
                    onSuccess: () => this.closeTermModal(),
                })
        },
        update () {
            this.form
                .transform((data) => ({
                    ...data,
                    _verified_attempt: false,
                    _curr_tab: this.currentTab,
                }))
                .put(this.route('mahasiswa.update.self'), {
                    onSuccess: () => {
                        this.lastInputStep = this.mahasiswa.input_step
                        this.onTabChanged(this.mahasiswa.input_step)
                    },
                })
        },
        uploadBerkas (fieldName) {
            this.uploads.doc_type = fieldName
            this.uploads.post(this.route('mahasiswa.upload.self'), {
                onSuccess: () => this.uploads.reset(fieldName),
            })
        },
        autoUploadBerkas (fieldName) {
            this.uploads[fieldName] && this.uploadBerkas(fieldName)
        },
        closeModal () {
            this.isModalVisible = false
        },
        showTermModal () {
            this.isTermConfirmVisible = true
        },
        closeTermModal () {
            this.isConfirmed = false
            this.isTermConfirmVisible = false
        },
        previewFile (fieldName) {
            this.imgUrl = `/mahasiswa/file?doc_type=${fieldName}`
            this.isModalVisible = true
        },
        onTabChanged (val) {
            if (
                this.lastInputStep > 3 ||
                val <= this.lastInputStep ||
                val === 4
            )
                this.currentTab = val
        },
        onDistrikSelected (val) {
            this.form.ref_distrik_id = val
        },
        onKampungSelected (val) {
            this.form.ref_kampung_id = val
        },
    },
}
</script>

<style scoped>
ul {
    list-style-type: square;
}
</style>
